import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ApiService } from '../../service/api_service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../components/auth/auth.service';

@Component({
  selector: 'app-addcampaign',
  template: require('./addcampaign.component.html'),
  styles: [require('./addcampaign.component.css')],
})
export class AddCampaign implements OnInit {
  model: NgbDateStruct;
  CampaignMaster: any;
  StateList = [];
  selectedItems = [];
  selectedItems1 = [];
  StateID: any = [];
  CityId: any = [];
  StateIDString;
  CityIDString;
  // dropdownSettings = {};
  Campaign: any = [];
  stateList: any = [];
  ProductList: any = [];
  CityList;
  displayedImage;
  busy: Subscription;
  uploadedImage;
  token: any;
  dropdownSettings: IDropdownSettings;
  dropdownSettings1: IDropdownSettings;
  f_chkString(p_value) {
    var Val = (p_value ? p_value.toString() : "").trim();
    return Val;
  }

  f_ChkNum(p_value) {
    var Num = Number(p_value);
    if (Num) {
      return Num;
    }
    return 0;
  }
  static parameters = [ApiService, ActivatedRoute, Router, HttpClient, ToastrService, AuthService]
  constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute, private router: Router, private http: HttpClient, private toastr: ToastrService, private authService: AuthService) {
    this.apiService = apiService;
  }

  ngOnInit() {
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.displayedImage = 'assets/images/home-image.jpg';
    this.InitCampaign();
    this.activatedRoute.queryParams.subscribe(params => {
      var _ID = Number(params['id']) ? Number(params['id']) : 0;
      this.Campaign.Campaigns_ID = _ID;
      this.GetCampaignDetailsByID(_ID);
    });
  }
  InitCampaign() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,

    };
    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
      
    };
    //this.displayedImage = 'Screenshot2021-06-15-16-45-51-6823b6155b0859d87d8a0f743b8170eb9d_20217814103058.jpg';//'assets/images/home-image.jpg';
    this.Campaign = {};
    this.Campaign.Campaigns_ID = 0;
    this.Campaign.CampaignApplicableFor = "0";
    this.Campaign.Country = "1";
    this.Campaign.City = "0";
    this.Campaign.State = "0";
    this.Campaign.ProductID = "0";
    this.Campaign.ProductName = "0";
    this.Campaign.IsActive = true;
    // this.getState();
    this.getProductList();


  }
  onStateSelect(item, IsSelect) {
    this.StateID = [];
    if (IsSelect == 'SelectAll' || IsSelect == 'DeSelectAll') {
      this.selectedItems = item;
    }
    this.selectedItems.forEach(item => {
      this.StateID.push(item.item_id);
    });
    console.log("arr", this.StateID)
    this.StateIDString = this.StateID.toString();
    this.getCity(this.StateIDString, 0);
  }

  onCitySelect(item, IsSelect) {
    this.CityId = [];
    if (IsSelect == 'SelectAll' || IsSelect == 'DeSelectAll') {
      this.selectedItems1 = item;
    }
    this.selectedItems1.forEach(item => {
      this.CityId.push(item.item_id);
    });
    console.log("arr", this.CityId)
    this.CityIDString = this.CityId.toString();
    console.log("city", this.CityIDString)
  }

  getState(data) {
    this.apiService.getStateForcampaign().subscribe((res: any) => {
      this.StateList = res.data;
      if (data.length > 0) {
        let States = data[0].StateID.split(',');
        this.selectedItems = [];
        States.forEach(States => {
          let index = this.StateList.map(item => item.item_id).indexOf(Number(States));
          if (index != -1) {
            let SelectedStates = { item_id: this.StateList[index].item_id, item_text: this.StateList[index].item_text };
            this.selectedItems.push(SelectedStates);
          }
        });
        this.StateIDString = data[0].StateID;
        // this.getCity(res.data[0], 1);
        console.log(this.selectedItems1);
      }
    })
  }

  getCity(data, Status) {
    if (Status == 1) {
      var StateID = data.StateID;
    } else {
      var StateID = data;
      this.selectedItems1 = [];

    }
    this.apiService.getCityForComapaign({ "StateID": StateID }).subscribe((res: any) => {
      this.CityList = res.data;
      if (Status == 1) {
        let CityList = this.CityList;
        let Cities = data.CityID.split(',');
        this.selectedItems1 = [];
        Cities.forEach(Cities => {
          let index = CityList.map(item => item.item_id).indexOf(Number(Cities));
          if (index != -1) {
            let SelectedCities = { item_id: CityList[index].item_id, item_text: CityList[index].item_text };
            this.selectedItems1.push(SelectedCities);
          }
        });
        // this.onCitySelect(this.selectedItems1,0);
      }

    })
  }

  getProductList() {
    this.busy = this.http.post('/api/Product/getProductList', {}).subscribe((res: any) => {
      console.log('res :', res);
      this.ProductList = res.productList;
    });
  }

  onCampaignApplicableChange() {
    if (this.Campaign.CampaignApplicableFor == 'Country') {
      this.StateIDString = "";
      this.CityIDString = "";
      this.selectedItems = [];
      this.selectedItems1 = [];

    }
    if (this.Campaign.CampaignApplicableFor == 'State') {
      this.CityIDString = "";
      this.selectedItems1 = [];
    }
    if (this.Campaign.CampaignApplicableFor == 0) {
      this.StateIDString = "";
      this.CityIDString = "";
      this.selectedItems = [];
      this.selectedItems1 = [];
    }

  }

  formData = new FormData();
  onFileSelected(event) {
    this.uploadedImage = event.target.files[0];
    if (this.uploadedImage.type == "image/jpeg" || this.uploadedImage.type == "image/png")  {
      this.uploadImage();
    }
    else (
      this.toastr.warning("Please Upload Jpg/Png File")
    )
  }

  uploadImage() {
    // CampaignUpload
    if (this.uploadedImage) {
      this.formData.append('image', this.uploadedImage, this.uploadedImage.name)
      console.log(this.formData.getAll('image')) //confirms file is being uploaded properly
      this.busy = this.http.post('/api/admin/CampaignImageUpload', this.formData)
        .subscribe(res => {
          console.log('res :', res);
          this.displayedImage = res["path"];
          this.toastr.success("Image Uploaded Successfully")
          // this.displayedImage ='file:///D:/Projects/enterofieldforce/public/upload/Campaign/Screenshot2021-06-15-16-45-51-6823b6155b0859d87d8a0f743b8170eb9d_202178112531338.jpg'
          // this.displayedImage = res["path"];
        });
    }
  }

  SaveCampaign() {
    this.Campaign.CampaignApplicableFor = this.f_chkString(this.Campaign.CampaignApplicableFor);
    this.Campaign.CampaignName = this.f_chkString(this.Campaign.CampaignName);
    this.Campaign.CampaignDesc = this.f_chkString(this.Campaign.CampaignDesc);

    if (this.Campaign.CampaignApplicableFor == 0) {
      this.toastr.warning('Please Select Campaign Applicable For');
      return false;
    }
    if ((this.Campaign.CampaignName).length == 0) {
      this.toastr.warning('Please Enter Campaign Name');
      return false;
    }
    if (this.Campaign.EffectiveStartDate == undefined) {
      this.toastr.warning('Please Enter Start Date');
      return false;
    }
    if (this.Campaign.EffectiveEndDate == undefined) {
      this.toastr.warning('Please Enter End Date');
      return false;
    }
    if (this.Campaign.ProductID == 0) {
      this.toastr.warning('Please Select Product');
      return false;
    }
    if (this.Campaign.CampaignApplicableFor == 'Country') {
      if (this.Campaign.Country == 1) {
        this.StateIDString = "";
        this.CityIDString = "";
        this.selectedItems = [];
        this.selectedItems1 = [];
      }
    }
    if (this.Campaign.CampaignApplicableFor == 'State') {
      this.CityIDString = "";
      this.selectedItems1 = [];
      if (this.selectedItems.length == 0) {
        this.toastr.warning('Please Select State');
        return false;
      }
    }
    if (this.Campaign.CampaignApplicableFor == 'City') {
      if (this.selectedItems1.length == 0) {
        this.toastr.warning('Please Select City');
        return false;
      }
    }


    if ((this.Campaign.CampaignDesc).length == 0) {
      this.toastr.warning('Please Enter Campaign Description');
      return false;
    }

    let index = this.ProductList.map(item => item.Product_ID).indexOf(Number(this.Campaign.ProductID));
    if (index != -1) {
      this.Campaign.ProductName = this.ProductList[index].Itemname;
    }

    var queryData = {
      CampaignApplicableFor: this.Campaign.CampaignApplicableFor,
      CampaignName: this.Campaign.CampaignName,
      EffectiveStartDate: this.Campaign.EffectiveStartDate,
      EffectiveEndDate: this.Campaign.EffectiveEndDate,
      ProductID: this.Campaign.ProductID,
      ProductName: this.Campaign.ProductName,
      CampaignDesc: this.Campaign.CampaignDesc,
      IsActive: this.Campaign.IsActive ? 1 : 0,
      CountryID: this.Campaign.Country,
      StateID: this.StateIDString,
      CityID: this.CityIDString,
      ImgPath: this.displayedImage,
      ID: this.token.id,
      Campaigns_ID: this.Campaign.Campaigns_ID
    }
    this.busy = this.http.post('/api/admin/SaveCampaignDetails', queryData).subscribe((res: any) => {
      console.log('res: ', res);
      if (res.data.length > 0) {
        if (res.data[0].flag == 1) {
          this.toastr.success(res.data[0].msg);
          this.router.navigate(['/campaigns']);
        }
        else {
          this.toastr.warning(res.data[0].flag)
        }
      }
    })
  }

  GetCampaignDetailsByID(id) {
    var data = { "ID": id };
    this.busy = this.http.post('/api/admin/GetCampaignDetailsByID', data).subscribe((res: any) => {
      if (res.data.length > 0) {
        this.getState(res.data);
        this.getCity(res.data[0], 1);
        this.Campaign = Object.assign({}, res.data[0]);
        this.Campaign.EffectiveStartDate = res.data[0].EffectiveStartDate.split("T")[0];
        this.Campaign.EffectiveEndDate = res.data[0].EffectiveEndDate.split("T")[0];
        this.displayedImage = res.data[0].displayedImage;

      } else {
        this.getState(res.data);
        this.router.navigate(['.'], { relativeTo: this.activatedRoute, queryParams: { id: 0 } });

      }
    })
  }

}

